/// <amd-module name="Feed/Legacy/Protocols/Upstream/UpstreamConnectToFeedPanel" />
import * as React from "react";

import { Dropdown, IDropdownOption } from "OfficeFabric/Dropdown";
import { Label } from "OfficeFabric/Label";

import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageService } from "VSS/Platform/Page";

import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";

import { CiConstants, FwLinks } from "Feed/Common/Constants/Constants";
import { FeedView, FeedVisibility } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { ExternalLink } from "Feed/Legacy/Components/ExternalLink";
import { LabelWithExternalLink } from "Feed/Legacy/Components/LabelWithExternalLink";
import * as OrganizationHelper from "Feed/Legacy/Helpers/OrganizationHelper";
import { IConnectToFeedProps } from "Feed/Legacy/Protocols/Common/IConnectToFeedProps";
import { CopyableTextField } from "Feed/Legacy/Protocols/Components/CopyableTextField";
import { UpstreamCiConstants } from "Feed/Legacy/Protocols/Upstream/Constants/UpstreamConstants";

export interface IUpstreamConnectToFeedProps extends IConnectToFeedProps {
    /**
     * the currently selected feed's views
     */
    feedViews: FeedView[];
}

export interface IUpstreamConnectToFeedPanelState {
    /**
     * the selected view in the dropdown
     */
    selectedView: FeedView;
}

export class UpstreamConnectToFeedPanel extends React.Component<
    IUpstreamConnectToFeedProps,
    IUpstreamConnectToFeedPanelState
> {
    constructor(props: IUpstreamConnectToFeedProps) {
        super(props);

        this.state = {
            selectedView:
                this.props.feed.view || // Feed has a view selected
                (this.props.feedViews && this.props.feedViews.length > 0 ? this.props.feedViews[0] : undefined)
        };
    }

    public render(): JSX.Element {
        let viewOptions: IDropdownOption[] = [];

        if (this.props.feedViews) {
            viewOptions = this.props.feedViews.map(view => ({
                key: view.id,
                text: "@" + view.name,
                data: view
            }));
        }

        return (
            <div className="connect-to-feed-panel upstream-connect-to-feed-panel">
                <div className="connect-to-feed-section">
                    <div className="connect-to-feed-section-title" role="heading" aria-level={2}>
                        {PackageResources.UpstreamConnectControl_AddFeedAsUpstreamSource}
                    </div>
                    {this._getContent(viewOptions)}
                </div>
            </div>
        );
    }

    private _getContent(viewOptions: IDropdownOption[]): JSX.Element {
        if (!viewOptions || viewOptions.length === 0) {
            return <Label>{PackageResources.FeedSettings_Views_NoViews}</Label>;
        }

        return (
            <div>
                <div className="connect-to-feed-views-dropdown">
                    <LabelWithExternalLink
                        pageContext={this.props.pageContext}
                        labelText={PackageResources.FeedViewDropdown_ConnectToFeed_Label}
                        linkText={PackageResources.FeedViewDropdown_ConnectToFeed_Label_Link}
                        href={FwLinks.ConnectToFeedViewWhatsThis}
                        ciContext={UpstreamCiConstants.UpstreamConnectToFeedPanel}
                    />
                    <Dropdown
                        className="views-dropdown"
                        ariaLabel={PackageResources.FeedViewDropdown_ConnectToFeed_Label}
                        options={viewOptions}
                        onChanged={option => this.setState({ selectedView: option.data })}
                        selectedKey={this.state.selectedView.id}
                    />
                </div>
                <div className="connect-to-feed-locator-textfield">
                    <Label className={"label"}>{PackageResources.UpstreamConnectControl_AddUpstreamUsingLocator}</Label>
                    <CopyableTextField
                        pageContext={this.props.pageContext}
                        text={OrganizationHelper.getUpstreamLocator(
                            this.props.pageContext.getService<IVssPageService>("IVssPageService").getData().hostName,
                            this.props.feed.name,
                            this.state.selectedView.name,
                            this.props.feed.project?.name
                        )}
                        telemetryProperties={{
                            commandName: CiConstants.CopyCommandInternalUpstreamLocator,
                            feedName: this.props.feed.name,
                            protocol: UpstreamCiConstants.ProtocolName
                        }}
                        buttonAriaLabel={PackageResources.UpstreamConnectControl_CopyInternalUpstreamLocatorAriaLabel}
                        textFieldAriaLabel={
                            PackageResources.UpstreamConnectControl_CopyInternalUpstreamLocatorTextFieldAriaLabel
                        }
                    />
                    <ExternalLink
                        pageContext={this.props.pageContext}
                        className="connect-to-feed-link"
                        href={FwLinks.ConnectToFeedUpstreamSourcesWhatsThis}
                        ciContext={UpstreamCiConstants.UpstreamConnectToFeedPanel}
                    >
                        {PackageResources.UpstreamConnectControl_WhatAreUpstreamSources}
                    </ExternalLink>
                </div>
                {(this.state.selectedView.visibility === FeedVisibility.Private ||
                    this.state.selectedView.visibility === FeedVisibility.Collection) && (
                    <MessageBar severity={MessageBarSeverity.Error}>
                        <span>
                            {Utils_String.format(
                                PackageResources.UpstreamConnectControl_ViewNotSharedWithAadTenant,
                                this.props.feed.name,
                                this.state.selectedView.name,
                                PackageResources.UpstreamConnectControl_FeedOwner
                            )}
                        </span>
                    </MessageBar>
                )}
            </div>
        );
    }
}
